export const ignoreErrors = [
    "Non-Error exception captured",
    "Non-Error promise rejection captured",
    "Extension context invalidated",
];
